module.exports = __webpack_public_path__ + "img/send.6bccdfd5.svg";